import { useState, useEffect, useRef } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,600;1,400&family=DM+Sans:wght@300;400;500&display=swap');

  .faq-root {
    font-family: 'DM Sans', sans-serif;
    background: #FAFAF8;
    min-height: 100vh;
    color: #1a1a18;
  }

  .faq-hero {
    background: #0f2318;
    padding: 80px 24px 72px;
    text-align: center;
    position: relative;
    overflow: hidden;
  }

  .faq-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse at 70% 0%, rgba(29,158,117,0.18) 0%, transparent 60%),
                radial-gradient(ellipse at 20% 100%, rgba(29,158,117,0.10) 0%, transparent 55%);
  }

  .faq-tag {
    display: inline-block;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #5DCAA5;
    background: rgba(93,202,165,0.12);
    border: 1px solid rgba(93,202,165,0.25);
    border-radius: 100px;
    padding: 5px 14px;
    margin-bottom: 24px;
    position: relative;
  }

  .faq-hero-title {
    font-family: 'Lora', Georgia, serif;
    font-size: clamp(28px, 5vw, 50px);
    font-weight: 600;
    color: #f5f3ee;
    max-width: 680px;
    margin: 0 auto 16px;
    line-height: 1.2;
    position: relative;
  }

  .faq-hero-sub {
    font-size: 16px;
    color: rgba(245,243,238,0.5);
    position: relative;
    font-weight: 300;
    max-width: 480px;
    margin: 0 auto;
    line-height: 1.6;
  }

  .faq-body {
    max-width: 760px;
    margin: 0 auto;
    padding: 64px 24px 96px;
  }

  .faq-category-label {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #1D9E75;
    margin: 52px 0 20px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .faq-category-label::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e8e6e0;
  }

  .faq-category-label:first-child {
    margin-top: 0;
  }

  .faq-item {
    border: 1px solid #e8e6e0;
    border-radius: 12px;
    margin-bottom: 10px;
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s;
    background: #fff;
  }

  .faq-item.open {
    border-color: rgba(29,158,117,0.3);
    box-shadow: 0 4px 24px rgba(29,158,117,0.07);
  }

  .faq-question {
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    padding: 20px 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #1a1a18;
    line-height: 1.5;
    transition: color 0.2s;
  }

  .faq-item.open .faq-question {
    color: #0f2318;
  }

  .faq-icon {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #f0f4f1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.2s, transform 0.3s;
  }

  .faq-item.open .faq-icon {
    background: #0f2318;
    transform: rotate(45deg);
  }

  .faq-icon svg {
    width: 12px;
    height: 12px;
    transition: stroke 0.2s;
  }

  .faq-item.open .faq-icon svg path {
    stroke: #5DCAA5;
  }

  .faq-answer-wrap {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.32s ease;
  }

  .faq-item.open .faq-answer-wrap {
    grid-template-rows: 1fr;
  }

  .faq-answer-inner {
    overflow: hidden;
  }

  .faq-answer {
    padding: 0 24px 22px;
    font-size: 15px;
    line-height: 1.8;
    color: #4a4a46;
    font-weight: 300;
    border-top: 1px solid #f0ede8;
    padding-top: 18px;
  }

  .faq-answer strong {
    color: #1a1a18;
    font-weight: 500;
  }

  .faq-answer a {
    color: #1D9E75;
    text-decoration: none;
    border-bottom: 1px solid rgba(29,158,117,0.3);
  }

  .faq-cta {
    background: #0f2318;
    border-radius: 16px;
    padding: 48px 40px;
    text-align: center;
    margin-top: 64px;
    position: relative;
    overflow: hidden;
  }

  .faq-cta::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse at 50% 110%, rgba(93,202,165,0.22) 0%, transparent 60%);
  }

  .faq-cta-title {
    font-family: 'Lora', Georgia, serif;
    font-size: 26px;
    font-weight: 600;
    color: #f5f3ee;
    margin: 0 0 10px;
    position: relative;
    z-index: 1;
  }

  .faq-cta-sub {
    font-size: 15px;
    color: rgba(245,243,238,0.5);
    margin: 0 0 28px;
    position: relative;
    z-index: 1;
    font-weight: 300;
  }

  .faq-cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #1D9E75;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    padding: 14px 28px;
    border-radius: 100px;
    border: none;
    cursor: pointer;
    position: relative;
    z-index: 1;
    transition: background 0.2s, transform 0.15s;
    text-decoration: none;
  }

  .faq-cta-btn:hover {
    background: #5DCAA5;
    transform: translateY(-1px);
  }

  /* Schema markup hidden visually but present for SEO */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
  }
`;

const faqs = [
  {
    category: "About Wispy AI",
    items: [
      {
        q: "What is Wispy AI?",
        a: "Wispy AI is an AI-powered chatbot platform built specifically for small business websites. It allows you to deploy a smart, conversational chatbot on your site that can answer customer questions 24/7, capture leads, and book appointments — all automatically, without any coding required.",
      },
      {
        q: "How is Wispy AI different from other chatbots?",
        a: "Most chatbots follow rigid scripts that break down the moment a customer asks something unexpected. Wispy AI uses large language model technology to understand natural, free-form questions and respond intelligently. It is also built with small businesses in mind — easy to set up, affordable, and focused on the tasks that matter most: answering questions, capturing leads, and booking appointments.",
      },
      {
        q: "What kinds of businesses use Wispy AI?",
        a: "Wispy AI is used by a wide range of small businesses including salons, clinics, law firms, restaurants, e-commerce stores, consultants, and service providers. Any business that receives customer enquiries online can benefit from having an AI chatbot on their website.",
      },
    ],
  },
  {
    category: "Setup & Installation",
    items: [
      {
        q: "How do I add a chatbot to my website?",
        a: "Adding Wispy AI to your website takes just a few minutes. Once you create your account, you will receive a small embed code (a snippet of JavaScript). You paste this code into your website's HTML — or into your CMS like WordPress, Webflow, or Shopify — and your chatbot goes live immediately. No developer is required.",
      },
      {
        q: "Does Wispy AI work without coding?",
        a: "Yes. Wispy AI is designed for business owners, not developers. The setup process involves copying and pasting a single line of code into your website. If you can add a Google Analytics tag or a Facebook Pixel, you can add Wispy AI. Most users are live within 10 minutes of signing up.",
      },
      {
        q: "Which website platforms does Wispy AI support?",
        a: "Wispy AI works on any website platform that allows you to add custom code, including WordPress, Webflow, Wix, Squarespace, Shopify, Framer, and custom-built HTML or React sites. If your platform supports a custom HTML embed, Wispy AI will work on it.",
      },
    ],
  },
  {
    category: "Features & Capabilities",
    items: [
      {
        q: "Can the chatbot answer questions about my specific business?",
        a: "Yes. During setup, you train Wispy AI on your business information — your services, pricing, opening hours, policies, FAQs, and anything else you want it to know. The chatbot then uses this information to answer questions accurately, in your brand's voice.",
      },
      {
        q: "Can Wispy AI book appointments automatically?",
        a: "Yes. Wispy AI integrates with your calendar and can show available time slots, confirm bookings, and send reminders to customers — all within the chat conversation, without any back-and-forth emails or phone calls.",
      },
      {
        q: "Does Wispy AI capture leads?",
        a: "Yes. Wispy AI can proactively engage website visitors, ask qualifying questions, and collect their name, email address, and specific needs before they leave your site. All captured leads are stored in your dashboard and can be exported or synced with your CRM.",
      },
      {
        q: "What languages does Wispy AI support?",
        a: "Wispy AI can converse in multiple languages. The chatbot automatically detects the language your visitor is writing in and responds accordingly, making it suitable for businesses with international customers.",
      },
    ],
  },
  {
    category: "Pricing & Plans",
    items: [
      {
        q: "How much does an AI chatbot cost for a small business?",
        a: "Wispy AI offers plans designed to be affordable for small businesses. You can get started for free to explore the platform, with paid plans available for businesses that need more conversations, integrations, and advanced features. Visit our pricing page for current plan details.",
      },
      {
        q: "Is there a free trial?",
        a: "Yes. You can try Wispy AI free without entering a credit card. The free plan lets you experience the core features and see how the chatbot performs on your website before committing to a paid plan.",
      },
    ],
  },
];

export default function WispyFAQ() {
  const [openItems, setOpenItems] = useState({});

  const toggle = (key) => {
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Build JSON-LD schema for SEO
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.flatMap((cat) =>
      cat.items.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      }))
    ),
  };

  return (
    <>
      <style>{styles}</style>

      {/* JSON-LD structured data for Google featured snippets */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />

      <div className="faq-root">
        <header className="faq-hero">
          <div className="faq-tag">Help & Support</div>
          <h1 className="faq-hero-title">Frequently Asked Questions</h1>
          <p className="faq-hero-sub">
            Everything you need to know about adding an AI chatbot to your small business website.
          </p>
        </header>

        <main className="faq-body">
          {faqs.map((category) => (
            <section key={category.category}>
              <div className="faq-category-label">{category.category}</div>
              {category.items.map((item, i) => {
                const key = `${category.category}-${i}`;
                const isOpen = !!openItems[key];
                return (
                  <div key={key} className={`faq-item${isOpen ? " open" : ""}`}>
                    <button
                      className="faq-question"
                      onClick={() => toggle(key)}
                      aria-expanded={isOpen}
                    >
                      <span>{item.q}</span>
                      <span className="faq-icon">
                        <svg viewBox="0 0 12 12" fill="none">
                          <path
                            d="M6 1v10M1 6h10"
                            stroke="#1a1a18"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                          />
                        </svg>
                      </span>
                    </button>
                    <div className="faq-answer-wrap">
                      <div className="faq-answer-inner">
                        <div className="faq-answer">{item.a}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </section>
          ))}

          <div className="faq-cta">
            <p className="faq-cta-title">Still have questions?</p>
            <p className="faq-cta-sub">
              Try Wispy AI free and see how it works on your website in minutes.
            </p>
            <a href="https://wispyaii.com" className="faq-cta-btn">
              Try Wispy AI free
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M3 8h10M9 4l4 4-4 4"
                  stroke="#fff"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </main>
      </div>
    </>
  );
}
